import React, { Component } from 'react';
import { withStyles  } from '@mui/styles';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Grid from '@mui/material/Grid';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import {
  ArrowBackIos,
  Delete,
  Edit,
  ExpandMore,
  Lock,
  Save,
  FilterNone
} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import { Button as ReactButton } from "@mui/material";
import Card from "@mui/material/Card";
import ErrorPage from '../errors/ErrorPage';
import PlacePackGrid from "../containers/PlacePackGrid";
import { WithTracking } from "./WithTracking";

const Button = WithTracking(ReactButton);

const styles = theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    overflow: "scroll",
    padding: 20
  },
  grow: {
    flexGrow: 1
  },
  stepper: {
    flexGrow: 1,
    width: 500,
    maxWidth: 700,
    padding: 0,
    background: theme.palette.common.white
  },
  stepperButton: {
    width: 225
  },
  flex: {
    flex: 1
  },
  bar: {
    minHeight: 50,
    background: theme.palette.common.white,
    borderBottom: '1px solid #c8c8c8'
  },
  buttons: {
    display: 'inline-block'
  },
  controls: {
    float: 'right'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  extraMargin: {
    marginRight: 20
  }
});


class PackagePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      innerHeight: window.innerHeight,
      builtDefault: false,
      builtActual: false,
      pack: {},
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { pkgId, order } = this.props;
    if (!order || !order.Packages) {
      return;
    }
    let pack = order.Packages.find(pkg => pkg.id === pkgId);
    if (!pack) {
      pack = this.buildPackage(this.props);
    }
    if (pack && isEmpty(this.state.pack)) {
      this.setState({ pack: pack });
    }
  }

  handleResize = (evt) => {
    this.setState({ innerHeight: window.innerHeight });
  };

  buildPackage = (props) => {
    return {
      id: '',
      name: '',
      IoId: props.order ? props.order.id : 0,
      rateType: 'CPM',
      rate: '',
      contractedQuantity: 1,
      cost: 0,
      adNameComments: ' ',
      totalContractedAmount: 0
    };
  };

  getPushRules = (pushSettings) => {
    const pushRules = [];
    if (pushSettings) {
      pushRules.push(pushSettings);
    }
    if (localStorage.getItem('soapLog')) {
      pushRules.push('soapLog')
    }
    if (localStorage.getItem('gamDirect')) {
      pushRules.push('gamDirect')
    }
    if (localStorage.getItem('forceStart')) {
      pushRules.push('forceStart')
    }
    return pushRules;
  };

  save = () => {
    const { pack } = this.state;
    pack.IoId = this.props.order.id;
    if (!pack.rateType) {
      pack.rateType = 'CPM';
    }
    pack.cost = this.computeTotalContractAmount(pack.contractedQuantity, pack.rate, pack.rateType);
    const errors = this.validatePackage(pack);
    if (isEmpty(errors)) {
      this.props.onSave(pack);
      this.props.onBack();
    } else {
      this.setState({ errors });
      this.props.onValidationError(errors);
    }
  };

  validatePackage = pack => {
    const errors = [];
    if (!pack.name) {
      errors.push('Package Name is required');
    }
    if (pack.name.length > 255) {
      errors.push('Name must be no more than 255 characters');
    }
    if (!pack.rateType) {
      errors.push('Rate Type is required');
    }
    if (!pack.rate) {
      errors.push('Rate is required');
    }
    if (!pack.contractedQuantity) {
      errors.push('Contracted Quantity is required');
    }
    if (pack.adNameComments && pack.adNameComments.length > 255) {
      errors.push('Comments must be no more than 255 characters');
    }
    return errors;
  };

// for CPM, its /1000.
// For CPD, its * number of days, which we don't know.
// For Flat Fee, it is just the rate.
// For CPA or CPC, we do not have the data to calculate it
  computeTotalContractAmount = (qty, rate, rateType) => {
    if (rateType === 'CPM') {
      const tca =  qty * rate / 1000;
      return Math.round (tca * 100) / 100;
    }
    if (rateType === 'CPD') {
      return 0;
    }
    if (rateType === 'Flat Fee') {
      return rate;
    }
    return qty * rate;
  };

  amountChanged = evt => {
    const { pack } = this.state;
    const { name, value } = evt.target;
    let val = value;
    if (name !== 'rateType') {
      if (value === '0' || value === '0.00') {
        val = '0';
      } else if (typeof value === 'string') {
        val = value.replace( /[^0-9.]/g, '' ).replace(/^0+/, '')
      }
    }
    let amount;
    switch(name) {
      case 'contractedQuantity':
        amount = this.computeTotalContractAmount(val, pack.rate, pack.rateType);
        break;
      case 'rate':
        amount = this.computeTotalContractAmount(pack.contractedQuantity, val, pack.rateType);
        break;
      case 'rateType':
        amount = this.computeTotalContractAmount(pack.contractedQuantity, pack.rate, val);
        break;
      default:
        return;
    }
    pack[name] = val;
    pack.cost = amount;
    this.setState({ pack });
  };

  /**
   * Handle most changes
   * Some fields need to be trimmed
   * Some changes calculate or clear other fields
   * @param evt
   */
  handleChange = evt => {
    const { pack: p } = this.state;
    const pack = Object.assign({}, p);
    const { name, value } = evt.target;
    pack[name] = value;
    this.setState({ pack: pack });
  };

  addError = err => {
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, err)
    }));
  };

  render() {
    const { errors, innerHeight, pack } = this.state;
    const {
      classes,
      order,
      error,
      onBack,
      canDelete,
      onDelete,
      pkgOrder,
      dateRun,
      onClone,
      isReadOnly,
      constants,
      togglePushSettings,
      setPushData,
      setPackageSelected,
      pushPlacementsFromPackage
    } = this.props;

    const icon = order && order.lock ? <Lock className={classes.leftIcon} /> : <Edit className={classes.leftIcon} />
    const isLocked = !!(order && order.lock);
    const rateTypes = ['CPM'];  //constants.ioRateTypes.map(rt => rt.name);
    let packTitle = 'New Package';
    if (pack.name) {
      packTitle = `${pack.name} : ${pack.id}`;
    }

    return (
      <div>
        <ErrorPage error={error} entity="pack">
          <div className={classes.root}>
            <Toolbar
              className={classes.bar}
            >
              <div className={classes.grow}>
                <div className={classes.buttons}>
                  <Button onClick={onBack} className={classes.extraMargin} color="primary" tracking={{action:"Back"}}>
                    <ArrowBackIos className={classes.leftIcon} />
                    Back
                  </Button>

                  {!isReadOnly && (
                  <Button onClick={this.save} color="primary" disabled={isLocked} tracking={{action:"Save"}}>
                    <Save className={classes.leftIcon} />
                    Save
                  </Button>)}

                  {!isReadOnly && (
                  <Button onClick={onClone} color="primary" disabled={isLocked} tracking={{action:"Clone"}}>
                    <FilterNone className={classes.leftIcon} />
                    Clone
                  </Button>)}

                  {!isReadOnly && (
                  <Button onClick={onDelete} color="secondary" disabled={isLocked || !canDelete()} tracking={{action:"Delete"}}>
                    <Delete className={classes.leftIcon} />
                    Delete
                  </Button>)}

                </div>
              </div>
            </Toolbar>
          </div>

          <div className={classes.root} style={{height: innerHeight - 160}}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    {icon}
                    <Typography variant="h6" className={classes.flex}>
                      {packTitle}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3} direction="row">
                      <Grid item xs={6}>
                        <TextField
                          variant="standard"
                          name="name"
                          value={pack.name}
                          label="Agency Package Name"
                          onChange={this.handleChange}
                          error={!!errors.name}
                          helperText={errors.name}
                          fullWidth
                          margin="normal" />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          variant="standard"
                          disabled
                          value={dateRun}
                          label="Placement Dates"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{ shrink: true }} />
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          variant="standard"
                          fullWidth
                          select
                          name="rateType"
                          onChange={this.amountChanged}
                          margin="normal"
                          label="Rate Type"
                          value={pack.rateType || 'CPM'}
                          error={!!errors.rateType}
                          helperText={errors.rateType}
                          InputLabelProps={{ shrink: true }}>
                          {rateTypes.map(rt => (
                            <MenuItem key={rt} value={rt}>
                              {rt}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          variant="standard"
                          name="rate"
                          value={pack.rate}
                          label="Rate"
                          onChange={this.amountChanged}
                          error={!!errors.rate}
                          helperText={errors.rate}
                          fullWidth
                          margin="normal"
                          InputLabelProps={{ shrink: true }} />
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          variant="standard"
                          name="contractedQuantity"
                          value={pack.contractedQuantity}
                          label="Contracted Quantity"
                          onChange={this.amountChanged}
                          error={!!errors.contractedQuantity}
                          helperText={errors.contractedQuantity}
                          fullWidth
                          margin="normal"
                          InputLabelProps={{ shrink: true }} />
                      </Grid>

                      <Grid item xs={8}>
                        <TextField
                          variant="standard"
                          name="adNameComments"
                          value={pack.adNameComments || ''}
                          label="Ad Name Comments"
                          onChange={this.handleChange}
                          error={!!errors.adNameComments}
                          helperText={errors.adNameComments}
                          fullWidth
                          margin="normal"
                          InputLabelProps={{ shrink: true }} />
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          variant="standard"
                          disabled
                          fullWidth
                          name="cost"
                          value={pack.cost}
                          label="Total Contracted Amount"
                          error={!!errors.cost}
                          helperText={errors.cost}
                          margin="normal"
                          InputLabelProps={{ shrink: true }} />
                      </Grid>

                    </Grid>

                  </AccordionDetails>
                </Accordion>

              </Grid>

            </Grid>

            {pack.id && <Grid item xs={12}>
            <Card>
              <PlacePackGrid
                order={pkgOrder}
                placements={pkgOrder && pkgOrder.Placements ? pkgOrder.Placements : []}
                isLocked={isLocked}
                context={"Package"}
                pkg={pack}
                pkgId={pack.id}
                pushPlacementsFromPackage={pushPlacementsFromPackage}
                onNotifyUpload={ids => this.onNotifyUpload(ids)}
                whitelist={constants.whitelistedDevs}
                setPackageSelected={setPackageSelected}
                isReadOnly={isReadOnly}
                togglePushSettings={togglePushSettings}
                setPushData={setPushData}
              />
            </Card>
          </Grid>
          }
          </div>
        </ErrorPage>
      </div>
    );
  }
}

PackagePage.defaultProps = {
  order: null,
  constants: null
};

PackagePage.propTypes = {
  classes: PropTypes.object.isRequired,
  constants: PropTypes.object,
  order: PropTypes.object,
};

export default withStyles(styles)(PackagePage);
